import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Footer from "../../../../../components/home_page/Footer";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  voucherTypeDefaultList,
  numberSeriesList,
  numberSeriesCreate,
  voucherTypeUpdate,
  voucherTypeSingleData,
  openModal,
  closeModal,
} from "../../../../../redux/actions/action-creator";
import FormData from "form-data";
import CreateConfirm from "../../../../../components/Modal/CreateConfirm";
import { toast } from "react-toastify";
import InputField from "../../../../../components/Input/InputField";
import DropdownLayout_1 from "../../../../../components/Dropdown/DropdownLayout_1";
import { useInputActionGroup } from "../../../../../components/Custom_Hooks/useInputActionGroup";
import { useFormHandler } from "../../../../../components/Custom_Hooks/useFormHandler";
import useClickOutside from "../../../../../components/Custom_Hooks/useClickOutsSide";
import DefineNumberSeries from "../../create/accounting_masters/DefineNumberSeries";
import MasterCreationFooter from "../../../../../components/Footer/Master_Footer/MasterCreationFooter";
import { voucher_number_periodicity_array } from "../../../../../components/Dummi_Data";

const initialState = {
  voucher_type_name: "",
  alias_name: "",
  status: "Active",
  select_type_of_voucher: "",
  select_type_of_voucher_id: "",
  abbreviation: "",
  activate_this_voucher_type: "Yes",
  define_multiple_numbering_series_for_vouchers: "No",
  show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh: "Yes",
  method_of_voucher_number: "Automatic",
  use_effective_date_for_vouchers: "No",
  allow_zero_valued_transactions: "No",
  make_this_voucher_type_as_optional_by_default: "No",
  allow_narration_in_voucher: "Yes",
  provide_narrations_for_each_ledger_in_voucher: "No",
  printing_voucher_after_saving: "No",
  enable_default_accounting_allocations: "",
  set_alter_default_accounting_entries: "",
  track_additional_costs_for_purchases: "",
  default_jurisdiction: "",
  default_title_to_print: "",
  print_formal_receipt_after_saving: "",
  use_for_pos_invoicing: "",
  message_to_print_1: "",
  message_to_print_2: "",
  default_bank: "",
  set_alter_declaration: "",
  use_a_manufacturing_journal: "",
  name_of_class: "",
  voucher_number_periodicity: "Yearly",
  voucher_number_prefix: "",
  voucher_number_suffix: "",
  prevent_creating_duplicate_voucher: "No",
};

const yes_no_array = [{ name: "Yes" }, { name: "No" }];
function VouchersType({ data_to_update, title, closeModal_sec }) {
  const { id: paramId } = useParams();
  const id = data_to_update?.id || paramId;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState(initialState);
  const [hasTransactions, setHasTransactions] = useState(false);
  const [defineNumberModal, setDefineNumberModal] = useState(false);
  const [hashtag, setHashtag] = useState(false);
  const [backspaceCount, setBackspaceCount] = useState(0);
  const [nameInput, setNameInput] = useState(null);
  const defineNumberSeriesRef = useRef(null);
  const isFirstLoad = useRef(true);
  const modal_state = useSelector((state) => state.common.modal_state);
  const voucher_type_default_data = useSelector(
    (state) => state.common.voucher_type_default_data,
  );
  const { userData = null } = useSelector((state) => state.auth);

  const inputRefs = useMemo(
    () => ({
      voucher_type_name: { current: null },
      alias_name: { current: null },
      status: { current: null },
      select_type_of_voucher: { current: null },
      select_type_of_voucher_id: { current: null },
      abbreviation: { current: null },
      activate_this_voucher_type: { current: null },
      method_of_voucher_number: { current: null },
      voucher_number_periodicity: { current: null },
      voucher_number_prefix: { current: null },
      voucher_number_suffix: { current: null },
      define_multiple_numbering_series_for_vouchers: { current: null },
      show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh: {
        current: null,
      },
      prevent_creating_duplicate_voucher: { current: null },
      use_effective_date_for_vouchers: { current: null },
      allow_zero_valued_transactions: { current: null },
      make_this_voucher_type_as_optional_by_default: { current: null },
      allow_narration_in_voucher: { current: null },
      provide_narrations_for_each_ledger_in_voucher: { current: null },
      printing_voucher_after_saving: { current: null },
      enable_default_accounting_allocations: { current: null },
      set_alter_default_accounting_entries: { current: null },
      track_additional_costs_for_purchases: { current: null },
      default_jurisdiction: { current: null },
      default_title_to_print: { current: null },
      print_formal_receipt_after_saving: { current: null },
      use_for_pos_invoicing: { current: null },
      message_to_print_1: { current: null },
      message_to_print_2: { current: null },
      default_bank: { current: null },
      set_alter_declaration: { current: null },
      use_a_manufacturing_journal: { current: null },
      name_of_class: { current: null },
    }),
    [],
  );

  // Initialize individual refs
  inputRefs.voucher_type_name = useRef(null);
  inputRefs.alias_name = useRef(null);
  inputRefs.status = useRef(null);
  inputRefs.select_type_of_voucher = useRef(null);
  inputRefs.select_type_of_voucher_id = useRef(null);
  inputRefs.abbreviation = useRef(null);
  inputRefs.activate_this_voucher_type = useRef(null);
  inputRefs.method_of_voucher_number = useRef(null);
  inputRefs.voucher_number_periodicity = useRef(null);
  inputRefs.voucher_number_prefix = useRef(null);
  inputRefs.voucher_number_suffix = useRef(null);
  inputRefs.define_multiple_numbering_series_for_vouchers = useRef(null);
  inputRefs.show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh =
    useRef(null);
  inputRefs.prevent_creating_duplicate_voucher = useRef(null);
  inputRefs.use_effective_date_for_vouchers = useRef(null);
  inputRefs.allow_zero_valued_transactions = useRef(null);
  inputRefs.make_this_voucher_type_as_optional_by_default = useRef(null);
  inputRefs.allow_narration_in_voucher = useRef(null);
  inputRefs.provide_narrations_for_each_ledger_in_voucher = useRef(null);
  inputRefs.printing_voucher_after_saving = useRef(null);
  inputRefs.enable_default_accounting_allocations = useRef(null);
  inputRefs.set_alter_default_accounting_entries = useRef(null);
  inputRefs.track_additional_costs_for_purchases = useRef(null);
  inputRefs.default_jurisdiction = useRef(null);
  inputRefs.default_title_to_print = useRef(null);
  inputRefs.print_formal_receipt_after_saving = useRef(null);
  inputRefs.use_for_pos_invoicing = useRef(null);
  inputRefs.message_to_print_1 = useRef(null);
  inputRefs.message_to_print_2 = useRef(null);
  inputRefs.default_bank = useRef(null);
  inputRefs.set_alter_declaration = useRef(null);
  inputRefs.use_a_manufacturing_journal = useRef(null);
  inputRefs.name_of_class = useRef(null);

  function getCurrentINputRef(name) {
    return inputRefs[name] || null;
  }

  const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const validations = {
    voucher_type_name: (value) => value.trim() !== "",
  };

  const refs = Object.keys(inputRefs).reduce((acc, name) => {
    acc[name] = {
      onFocus: () => {
        const ref = getCurrentINputRef(name);
        if (ref?.current?.disabled) {
          return;
        }
        if (ref) {
          setNameInput(ref);
          ref?.current?.setSelectionRange(0, ref?.current?.value?.length);
        }
        if (
          [
            "select_type_of_voucher",
            "status",
            "activate_this_voucher_type",
            "define_multiple_numbering_series_for_vouchers",
            "show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh",
            "method_of_voucher_number",
            "use_effective_date_for_vouchers",
            "allow_zero_valued_transactions",
            "make_this_voucher_type_as_optional_by_default",
            "allow_narration_in_voucher",
            "provide_narrations_for_each_ledger_in_voucher",
            "printing_voucher_after_saving",
            "enable_default_accounting_allocations",
            "set_alter_default_accounting_entries",
            "track_additional_costs_for_purchases",
            "print_formal_receipt_after_saving",
            "set_alter_declaration",
            "use_a_manufacturing_journal",
            "use_for_pos_invoicing",
            "voucher_number_periodicity",
            "prevent_creating_duplicate_voucher",
          ].includes(name)
        ) {
          dispatch(openModal(name));
        }
      },
      onBlur: (value) => {
        if (
          name === "voucher_type_name" &&
          !value.trim() &&
          submitConfirmRef.current !== "Quit"
        ) {
          getCurrentINputRef(name)?.current?.focus();
        }
        if (
          [
            "select_type_of_voucher",
            "status",
            "activate_this_voucher_type",
            "define_multiple_numbering_series_for_vouchers",
            "show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh",
            "method_of_voucher_number",
            "use_effective_date_for_vouchers",
            "allow_zero_valued_transactions",
            "make_this_voucher_type_as_optional_by_default",
            "allow_narration_in_voucher",
            "provide_narrations_for_each_ledger_in_voucher",
            "printing_voucher_after_saving",
            "enable_default_accounting_allocations",
            "set_alter_default_accounting_entries",
            "track_additional_costs_for_purchases",
            "print_formal_receipt_after_saving",
            "set_alter_declaration",
            "use_a_manufacturing_journal",
            "use_for_pos_invoicing",
            "voucher_number_periodicity",
            "prevent_creating_duplicate_voucher",
          ].includes(name)
        ) {
          dispatch(closeModal(name));
        }
      },
    };
    return acc;
  }, {});

  const toYesNo = (val) => {
    if (val === 1 || val === "1" || val === "Yes" || val === true) return "Yes";
    if (val === 0 || val === "0" || val === "No" || val === false) return "No";
    return val || "No";
  };

  const {
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    setSubmitConfirm,
    submitConfirm,
    handleDropdownClick,
  } = useInputActionGroup({
    data: state,
    setData: setState,
    validations,
    refs,
    check_dropdown: Object.keys(modal_state).some((key) => modal_state[key]),
    inputRefs,
  });

  const handleDropdownClickCustom = (name, value) => {
    if (name === "define_multiple_numbering_series_for_vouchers" && value === "Yes") {
      setDefineNumberModal(true);
    }
    handleDropdownClick(name, value);
  };

  useEffect(() => {
    if (!isFirstLoad.current && state.define_multiple_numbering_series_for_vouchers === "Yes") {
      setDefineNumberModal(true);
    }
  }, [state.define_multiple_numbering_series_for_vouchers]);

  useEffect(() => {
    inputRefs.voucher_type_name.current?.focus();
  }, []);

  const modalStateRef = useRef(modal_state);
  useEffect(() => {
    modalStateRef.current = modal_state;
  }, [modal_state]);

  const submitConfirmRef = useRef(submitConfirm);
  useEffect(() => {
    submitConfirmRef.current = submitConfirm;
  }, [submitConfirm]);

  const defineNumberModalRef = useRef(defineNumberModal);
  useEffect(() => {
    defineNumberModalRef.current = defineNumberModal;
  }, [defineNumberModal]);

  useEffect(() => {
    if (defineNumberModal) {
      document.activeElement?.blur();
    }
  }, [defineNumberModal]);


  const validateForm = () => {
    if (defineNumberModalRef.current) {
      defineNumberSeriesRef.current?.submit();
      return false;
    }
    if (!state.voucher_type_name?.trim()) {
      toast.error("Required Voucher Type Name", {
        position: toast.POSITION.TOP_CENTER,
      });
      getCurrentINputRef("voucher_type_name")?.current?.focus();
      return false;
    }
    return true;
  };

  const { handleSubmit, loading, handleFocusReset } = useFormHandler({
    validateForm,
    prepareFormData: () => {
      //console.log(userData);
      const formData = new FormData();
      formData.append("company_id", userData?.company_id);
      formData.append("voucher_type_id", state?.select_type_of_voucher_id);
      Object.entries(state).forEach(([key, value]) =>
        formData.append(key, value),
      );
      formData.append("id", id);
      return formData;
    },
    submitForm: (data) => dispatch(voucherTypeUpdate(data)),
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => handleSubmit(new Event("submit")),
      },
    ],
    first_ref: inputRefs.voucher_type_name,
    closeModal: () =>
      navigate("/chart-of-account-accounting-master-voucherstype"),
    setSubmitConfirm,
    submitConfirm,
  });

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape") {
        if (defineNumberModalRef.current) return;
        if (submitConfirmRef.current) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleFocusReset();
          return;
        }

        const activeModals = Object.keys(modalStateRef.current || {}).filter(
          (key) => modalStateRef.current[key],
        );
        const closableModals = [
          "select_type_of_voucher",
          "status",
          "activate_this_voucher_type",
          "define_multiple_numbering_series_for_vouchers",
          "show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh",
          "method_of_voucher_number",
          "use_effective_date_for_vouchers",
          "allow_zero_valued_transactions",
          "make_this_voucher_type_as_optional_by_default",
          "allow_narration_in_voucher",
          "provide_narrations_for_each_ledger_in_voucher",
          "printing_voucher_after_saving",
          "enable_default_accounting_allocations",
          "set_alter_default_accounting_entries",
          "track_additional_costs_for_purchases",
          "print_formal_receipt_after_saving",
          "set_alter_declaration",
          "use_a_manufacturing_journal",
          "use_for_pos_invoicing",
          "voucher_number_periodicity",
          "prevent_creating_duplicate_voucher",
        ];

        const openClosableModals = activeModals.filter((modal) =>
          closableModals.includes(modal),
        );

        if (openClosableModals?.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openClosableModals.forEach((modal) => dispatch(closeModal(modal)));
        } else {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitConfirmRef.current = "Quit";
          setSubmitConfirm("Quit");
          document.activeElement?.blur();
        }
      }
    };
    window.addEventListener("keydown", handleKeyPress, true);
    return () => window.removeEventListener("keydown", handleKeyPress, true);
  }, [dispatch, inputRefs, setSubmitConfirm]);

  useEffect(() => {
    const data = new FormData();
    data.append("company_id", userData?.company_id);
    dispatch(voucherTypeDefaultList(data));
  }, [dispatch, userData?.company_id]);

  useEffect(() => {
    let data = new FormData();
    data.append("id", data_to_update?.id);
    data.append("company_id", userData?.company_id);
    dispatch(voucherTypeSingleData(data)).then((response) => {
      if (response.status) {
        setHasTransactions(response?.data?.has_transactions || false);
        setState({
          voucher_type_name: response?.data?.voucher_type_name,
          alias_name: response?.data?.alias_name,
          status: response?.data?.status,
          select_type_of_voucher: response?.data?.select_type_of_voucher,
          select_type_of_voucher_id: response?.data?.voucher_type_id,
          abbreviation: response?.data?.abbreviation,
          activate_this_voucher_type: toYesNo(
            response?.data?.activate_this_voucher_type,
          ),
          define_multiple_numbering_series_for_vouchers: toYesNo(
            response?.data?.define_multiple_numbering_series_for_vouchers,
          ),
          show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh:
            toYesNo(
              response?.data
                ?.show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh,
            ),
          method_of_voucher_number: response?.data?.method_of_voucher_number,
          use_effective_date_for_vouchers: toYesNo(
            response?.data?.use_effective_date_for_vouchers,
          ),
          allow_zero_valued_transactions: toYesNo(
            response?.data?.allow_zero_valued_transactions,
          ),
          make_this_voucher_type_as_optional_by_default: toYesNo(
            response?.data?.make_this_voucher_type_as_optional_by_default,
          ),
          allow_narration_in_voucher: toYesNo(
            response?.data?.allow_narration_in_voucher,
          ),
          provide_narrations_for_each_ledger_in_voucher: toYesNo(
            response?.data?.provide_narrations_for_each_ledger_in_voucher,
          ),
          printing_voucher_after_saving: toYesNo(
            response?.data?.printing_voucher_after_saving,
          ),
          enable_default_accounting_allocations: toYesNo(
            response?.data?.enable_default_accounting_allocations,
          ),
          set_alter_default_accounting_entries: toYesNo(
            response?.data?.set_alter_default_accounting_entries,
          ),
          track_additional_costs_for_purchases: toYesNo(
            response?.data?.track_additional_costs_for_purchases,
          ),
          default_jurisdiction: response?.data?.default_jurisdiction,
          default_title_to_print: response?.data?.default_title_to_print,
          print_formal_receipt_after_saving: toYesNo(
            response?.data?.print_formal_receipt_after_saving || "No",
          ),
          use_for_pos_invoicing: toYesNo(response?.data?.use_for_pos_invoicing),
          message_to_print_1: response?.data?.message_to_print_1,
          message_to_print_2: response?.data?.message_to_print_2,
          default_bank: response?.data?.default_bank,
          set_alter_declaration: toYesNo(response?.data?.set_alter_declaration),
          use_a_manufacturing_journal: toYesNo(
            response?.data?.use_a_manufacturing_journal || "No",
          ),
          voucher_number_periodicity:
            response?.data?.voucher_number_periodicity || "Yearly",
          voucher_number_prefix: response?.data?.voucher_number_prefix || "",
          voucher_number_suffix: response?.data?.voucher_number_suffix || "",
          prevent_creating_duplicate_voucher:
            response?.data?.prevent_creating_duplicate_voucher || "No",
        });
        setTimeout(() => {
          isFirstLoad.current = false;
        }, 100);
      }
    });
  }, [dispatch, id, userData?.company_id]);

  useEffect(() => {
    if (!isFirstLoad.current && state.select_type_of_voucher_id) {
      const selectedVoucher = voucher_type_default_data?.find(
        (v) => String(v.id) === String(state.select_type_of_voucher_id),
      );
      if (selectedVoucher) {
        setState((prevState) => ({
          ...prevState,
          abbreviation: selectedVoucher.abbreviation || prevState.abbreviation,
          method_of_voucher_number:
            selectedVoucher.method_of_voucher_number ||
            prevState.method_of_voucher_number,
          //activate_this_voucher_type: toYesNo(selectedVoucher.activate_this_voucher_type),
          use_effective_date_for_vouchers: toYesNo(
            selectedVoucher.use_effective_date_for_vouchers,
          ),
          allow_zero_valued_transactions: toYesNo(
            selectedVoucher.allow_zero_valued_transactions,
          ),
          make_this_voucher_type_as_optional_by_default: toYesNo(
            selectedVoucher.make_this_voucher_type_as_optional_by_default,
          ),
          allow_narration_in_voucher: toYesNo(
            selectedVoucher.allow_narration_in_voucher,
          ),
          provide_narrations_for_each_ledger_in_voucher: toYesNo(
            selectedVoucher.provide_narrations_for_each_ledger_in_voucher,
          ),
          printing_voucher_after_saving: toYesNo(
            selectedVoucher.printing_voucher_after_saving,
          ),
          use_a_manufacturing_journal: toYesNo(
            selectedVoucher.use_a_manufacturing_journal,
          ),
          track_additional_costs_for_purchases: toYesNo(
            selectedVoucher.track_additional_costs_for_purchases,
          ),
          enable_default_accounting_allocations: toYesNo(
            selectedVoucher.enable_default_accounting_allocations,
          ),
          set_alter_default_accounting_entries: toYesNo(
            selectedVoucher.set_alter_default_accounting_entries,
          ),
          use_for_pos_invoicing: toYesNo(selectedVoucher.use_for_pos_invoicing),
          print_formal_receipt_after_saving: toYesNo(
            selectedVoucher.print_formal_receipt_after_saving,
          ),
        }));
      }
    }
  }, [state.select_type_of_voucher_id, voucher_type_default_data]);

  const mappedVoucherTypeData = useMemo(
    () =>
      voucher_type_default_data?.map((item) => ({
        ...item,
        name: item.voucher_type_name,
      })) || [],
    [voucher_type_default_data],
  );

  const {
    voucher_type_name,
    alias_name,
    status,
    select_type_of_voucher,
    select_type_of_voucher_id,
    abbreviation,
    activate_this_voucher_type,
    define_multiple_numbering_series_for_vouchers,
    show_unsed_vch_nos_in_transaction_for_retian_original_vch_no_beh,
    method_of_voucher_number,
    use_effective_date_for_vouchers,
    allow_zero_valued_transactions,
    make_this_voucher_type_as_optional_by_default,
    allow_narration_in_voucher,
    provide_narrations_for_each_ledger_in_voucher,
    printing_voucher_after_saving,
    enable_default_accounting_allocations,
    set_alter_default_accounting_entries,
    track_additional_costs_for_purchases,
    default_jurisdiction,
    default_title_to_print,
    print_formal_receipt_after_saving,
    use_for_pos_invoicing,
    message_to_print_1,
    message_to_print_2,
    default_bank,
    set_alter_declaration,
    use_a_manufacturing_journal,
    name_of_class,
    voucher_number_periodicity,
    voucher_number_prefix,
    voucher_number_suffix,
    prevent_creating_duplicate_voucher,
  } = state;

  if (
    typeof voucher_type_default_data === "undefined" ||
    voucher_type_default_data === null
  ) {
    return null;
  }

  return (
    <div
      className="section"
      style={{
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "100%",
        zIndex: 10000,
      }}
    >
      <div
        className="detail border position-relative"
        style={{ width: "100%", minWidth: "100%" }}
      >
        {submitConfirm === "Accept" || submitConfirm === "Quit" ? (
          <CreateConfirm
            message={submitConfirm}
            handleSubmit={(e) => {
              if (submitConfirm === "Accept") {
                handleSubmit(e);
              } else {
                navigate("/chart-of-account-accounting-master-voucherstype");
              }
            }}
            handleFocusReset={handleFocusReset}
          />
        ) : null}
        {defineNumberModal ? (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "calc(100% - 4vh)",
              zIndex: 10000,
            }}
          >
            <DefineNumberSeries
              ref={defineNumberSeriesRef}
              setDefineNumberModal={setDefineNumberModal}
              name={state.voucher_type_name}
              ref_name={
                inputRefs.define_multiple_numbering_series_for_vouchers
              }
              state={state}
              setState={setState}
              inputRefs={inputRefs}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              modal_state={modal_state}
              handleDropdownClick={handleDropdownClick}
            />
          </div>
        ) : null}
        <div
          className="container-fluid p-0"
          style={{ background: "rgba(0,0,0,0.4)", height: "91.7vh" }}
        >
          <form autoComplete="off" onSubmit={handleSubmit} style={{ pointerEvents: defineNumberModal ? 'none' : 'auto' }}>
            <div className="row table_date_header">
              <div className="col-12 ps-3  d-flex justify-content-between  table_header_font">
                <b> Voucher Type Alteration </b>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12"
                style={{
                  padding: "5px 10px 5px 20px",
                  background: "#fff",
                  overflow: "hidden",
                  width: "100%",
                  borderRight: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                <div className="row mt-2">
                  <div className="col-6">
                    <InputField
                      lable="Name"
                      name="voucher_type_name"
                      value={voucher_type_name}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.voucher_type_name}
                      autoFocus={true}
                      data={state}
                      setData={setState}
                    />
                    <InputField
                      lable="(alias)"
                      name="alias_name"
                      value={alias_name}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.alias_name}
                      data={state}
                      setData={setState}
                    />
                  </div>
                  <div className="col-6">
                    <div className="d-flex justify-content-between align-item-center">
                      <label className="lab-1">&nbsp;</label>
                      <label>&nbsp;</label>
                      <label>&nbsp;</label>
                    </div>
                    {/*<InputField
                      lable="Status"
                      name="status"
                      value={status}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.status}
                      data={state}
                      setData={setState}
                    />
                    {modal_state.status && (
                      <DropdownLayout_1
                        title="List of Status"
                        state={modal_state.status}
                        data={state}
                        setData={setState}
                        input_value={status}
                        input_key="status"
                        rawData={[{ name: 'Active' }, { name: 'Inactive' }]}
                        ref={inputRefs.status}
                        inputRefs={inputRefs}
                        handleDropdownClick={handleDropdownClick}
                      />
                    )}*/}
                  </div>
                </div>
                <div className="row height" style={{ border: "1px solid #aaa" }}>
                  <div className="col-7" style={{ borderRight: "1px solid #aaa", paddingRight: "15px" }}>
                    <div className="row">
                      <div className="col text-decoration-underline">
                        <b>General</b>
                      </div>
                    </div>
                    <InputField
                      lable="Select type of voucher"
                      name="select_type_of_voucher"
                      value={select_type_of_voucher}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.select_type_of_voucher}
                      data={state}
                      setData={setState}
                      isDisabled={hasTransactions}
                    />
                    {modal_state.select_type_of_voucher && (
                      <DropdownLayout_1
                        title="List of Voucher Types"
                        state={modal_state.select_type_of_voucher}
                        data={state}
                        setData={setState}
                        input_value={select_type_of_voucher}
                        input_key="select_type_of_voucher"
                        input_id="select_type_of_voucher_id"
                        rawData={mappedVoucherTypeData}
                        ref={inputRefs.select_type_of_voucher}
                        inputRefs={inputRefs}
                        handleDropdownClick={handleDropdownClick}
                      />
                    )}
                    <InputField
                      lable="Abbreviation"
                      name="abbreviation"
                      value={abbreviation}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.abbreviation}
                      data={state}
                      setData={setState}
                      isDisabled={hasTransactions}
                    />
                    <div style={{ borderTop: "1px solid #aaa", marginLeft: "-15px", marginRight: "-15px", marginTop: "5px", marginBottom: "5px" }}></div>
                    <InputField
                      lable="Activate this voucher Type"
                      name="activate_this_voucher_type"
                      value={activate_this_voucher_type}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.activate_this_voucher_type}
                      isDrop={true}
                      show_drop={modal_state.activate_this_voucher_type}
                      data={state}
                      setData={setState}
                      handleDropdownClick={handleDropdownClick}
                    />

                    <InputField
                      lable="Method of voucher numbering"
                      name="method_of_voucher_number"
                      value={method_of_voucher_number}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.method_of_voucher_number}
                      data={state}
                      setData={setState}
                      isDisabled={hasTransactions}
                    />
                    {modal_state.method_of_voucher_number && (
                      <DropdownLayout_1
                        title="Method of Numbering"
                        state={modal_state.method_of_voucher_number}
                        data={state}
                        setData={setState}
                        input_value={method_of_voucher_number}
                        input_key="method_of_voucher_number"
                        rawData={[{ name: "Automatic" }, { name: "Manual" }]}
                        ref={inputRefs.method_of_voucher_number}
                        inputRefs={inputRefs}
                        handleDropdownClick={handleDropdownClick}
                      />
                    )}
                    {state.method_of_voucher_number === "Automatic" && (
                      <>
                        <InputField
                          lable="Set/Alter additional numbering details"
                          name="define_multiple_numbering_series_for_vouchers"
                          value={define_multiple_numbering_series_for_vouchers}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.define_multiple_numbering_series_for_vouchers}
                          isDrop={true}
                          show_drop={
                            modal_state.define_multiple_numbering_series_for_vouchers
                          }
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClickCustom}
                          height="auto"
                        />
                      </>
                    )}
                    {state.method_of_voucher_number === "Manual" && (
                      <InputField
                        lable="Prevent creating duplicate voucher"
                        name="prevent_creating_duplicate_voucher"
                        value={prevent_creating_duplicate_voucher}
                        handleChange={handleChange}
                        handleFocus={handleFocus}
                        handleBlur={handleBlur}
                        handleKeyDown={handleKeyDown}
                        ref={inputRefs.prevent_creating_duplicate_voucher}
                        isDrop={true}
                        show_drop={
                          modal_state.prevent_creating_duplicate_voucher
                        }
                        data={state}
                        setData={setState}
                        handleDropdownClick={handleDropdownClick}
                        height="auto"
                      />
                    )}
                    <div style={{ borderTop: "1px solid #aaa", marginLeft: "-15px", marginRight: "-15px", marginTop: "5px", marginBottom: "5px" }}></div>
                    <InputField
                      lable="Use effective dates for Vouchers"
                      name="use_effective_date_for_vouchers"
                      value={use_effective_date_for_vouchers}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.use_effective_date_for_vouchers}
                      isDrop={true}
                      show_drop={modal_state.use_effective_date_for_vouchers}
                      data={state}
                      setData={setState}
                      handleDropdownClick={handleDropdownClick}
                      height="auto"
                    />
                    <InputField
                      lable="Allow zero-valued transactions"
                      name="allow_zero_valued_transactions"
                      value={allow_zero_valued_transactions}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.allow_zero_valued_transactions}
                      isDrop={true}
                      show_drop={modal_state.allow_zero_valued_transactions}
                      data={state}
                      setData={setState}
                      handleDropdownClick={handleDropdownClick}
                      height="auto"
                    />
                    {[
                      "Contra",
                      "Credit Note",
                      "Debit Note",
                      "Payment",
                      "Purchase",
                      "Receipt",
                      "Sales",
                      "Delivery Note",
                      "Receipt Note",
                      "Purchase Order",
                      "Sales Order",
                      "Stock Journal",
                    ].includes(state.select_type_of_voucher) && (
                        <InputField
                          lable="Make this voucher type as 'Optional' by default"
                          name="make_this_voucher_type_as_optional_by_default"
                          value={make_this_voucher_type_as_optional_by_default}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={
                            inputRefs.make_this_voucher_type_as_optional_by_default
                          }
                          isDrop={true}
                          show_drop={
                            modal_state.make_this_voucher_type_as_optional_by_default
                          }
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClick}
                          height="auto"
                        />
                      )}
                    <InputField
                      lable="Allow narration in voucher"
                      name="allow_narration_in_voucher"
                      value={allow_narration_in_voucher}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.allow_narration_in_voucher}
                      isDrop={true}
                      show_drop={modal_state.allow_narration_in_voucher}
                      data={state}
                      setData={setState}
                      handleDropdownClick={handleDropdownClick}
                    />
                    {[
                      "Contra",
                      "Credit Note",
                      "Debit Note",
                      "Journal",
                      "Payment",
                      "Purchase",
                      "Receipt",
                      "Sales",
                    ].includes(state.select_type_of_voucher) && (
                        <InputField
                          lable="Provide narration for each ledger in voucher"
                          name="provide_narrations_for_each_ledger_in_voucher"
                          value={provide_narrations_for_each_ledger_in_voucher}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={
                            inputRefs.provide_narrations_for_each_ledger_in_voucher
                          }
                          isDrop={true}
                          show_drop={
                            modal_state.provide_narrations_for_each_ledger_in_voucher
                          }
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClick}
                          height="auto"
                        />
                      )}
                    {state.select_type_of_voucher === "Stock Journal" && (
                      <InputField
                        lable="Use a Manufacturing Journal"
                        name="use_a_manufacturing_journal"
                        value={use_a_manufacturing_journal}
                        handleChange={handleChange}
                        handleFocus={handleFocus}
                        handleBlur={handleBlur}
                        handleKeyDown={handleKeyDown}
                        ref={inputRefs.use_a_manufacturing_journal}
                        isDrop={true}
                        show_drop={modal_state.use_a_manufacturing_journal}
                        data={state}
                        setData={setState}
                        handleDropdownClick={handleDropdownClick}
                      />
                    )}
                    {[
                      "Debit Note",
                      "Journal",
                      "Payment",
                      "Purchase",
                      "Physical Stock",
                      "Stock Journal",
                    ].includes(state.select_type_of_voucher) && (
                        <InputField
                          lable="Track Additional Costs for Purchases"
                          name="track_additional_costs_for_purchases"
                          value={track_additional_costs_for_purchases}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.track_additional_costs_for_purchases}
                          isDrop={true}
                          show_drop={
                            modal_state.track_additional_costs_for_purchases
                          }
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClick}
                          height="auto"
                        />
                      )}
                    {[
                      "Contra",
                      "Credit Note",
                      "Debit Note",
                      "Payment",
                      "Purchase",
                      "Receipt",
                      "Sales",
                      "Delivery Note",
                      "Receipt Note",
                      "Purchase Order",
                      "Sales Order",
                    ].includes(state.select_type_of_voucher) && (
                        <>
                          <InputField
                            lable="Enable default accounting allocations"
                            name="enable_default_accounting_allocations"
                            value={enable_default_accounting_allocations}
                            handleChange={handleChange}
                            handleFocus={handleFocus}
                            handleBlur={handleBlur}
                            handleKeyDown={handleKeyDown}
                            ref={inputRefs.enable_default_accounting_allocations}
                            isDrop={true}
                            show_drop={
                              modal_state.enable_default_accounting_allocations
                            }
                            data={state}
                            setData={setState}
                            handleDropdownClick={handleDropdownClick}
                            height="auto"
                          />
                          {state.enable_default_accounting_allocations ===
                            "Yes" && (
                              <InputField
                                lable="Set/Alter default Accounting Entries"
                                name="set_alter_default_accounting_entries"
                                value={set_alter_default_accounting_entries}
                                handleChange={handleChange}
                                handleFocus={handleFocus}
                                handleBlur={handleBlur}
                                handleKeyDown={handleKeyDown}
                                ref={inputRefs.set_alter_default_accounting_entries}
                                isDrop={true}
                                show_drop={
                                  modal_state.set_alter_default_accounting_entries
                                }
                                data={state}
                                setData={setState}
                                handleDropdownClick={handleDropdownClick}
                                height="auto"
                              />
                            )}
                        </>
                      )}
                  </div>
                  <div className="col-5" style={{ paddingLeft: "15px" }}>
                    <div className="row">
                      <div className="col text-decoration-underline">
                        <b>Printing</b>
                      </div>
                    </div>
                    <InputField
                      lable="Print voucher after saving"
                      name="printing_voucher_after_saving"
                      value={printing_voucher_after_saving}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.printing_voucher_after_saving}
                      isDrop={true}
                      show_drop={modal_state.printing_voucher_after_saving}
                      data={state}
                      setData={setState}
                      handleDropdownClick={handleDropdownClick}
                    />
                    {state.select_type_of_voucher === "Sales" && (
                      <>
                        <InputField
                          lable="Use for POS invoicing"
                          name="use_for_pos_invoicing"
                          value={use_for_pos_invoicing}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.use_for_pos_invoicing}
                          isDrop={true}
                          show_drop={modal_state.use_for_pos_invoicing}
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClick}
                        />
                        {state.use_for_pos_invoicing === "Yes" && (
                          <>
                            <InputField
                              lable="Message to print (1)"
                              name="message_to_print_1"
                              value={message_to_print_1}
                              handleChange={handleChange}
                              handleFocus={handleFocus}
                              handleBlur={handleBlur}
                              handleKeyDown={handleKeyDown}
                              ref={inputRefs.message_to_print_1}
                              data={state}
                              setData={setState}
                            />
                            <InputField
                              lable="Message to print (2)"
                              name="message_to_print_2"
                              value={message_to_print_2}
                              handleChange={handleChange}
                              handleFocus={handleFocus}
                              handleBlur={handleBlur}
                              handleKeyDown={handleKeyDown}
                              ref={inputRefs.message_to_print_2}
                              data={state}
                              setData={setState}
                            />
                          </>
                        )}
                        <InputField
                          lable="Default Bank"
                          name="default_bank"
                          value={default_bank}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.default_bank}
                          data={state}
                          setData={setState}
                        />
                      </>
                    )}
                    {(state.select_type_of_voucher === "Purchase Order" ||
                      state.select_type_of_voucher === "Credit Note" ||
                      state.select_type_of_voucher === "Sales" ||
                      state.select_type_of_voucher === "Delivery Note") && (
                        <InputField
                          lable="Default Jurisdiction"
                          name="default_jurisdiction"
                          value={default_jurisdiction}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.default_jurisdiction}
                          data={state}
                          setData={setState}
                        />
                      )}
                    <InputField
                      lable="Default Title to print"
                      name="default_title_to_print"
                      value={default_title_to_print}
                      handleChange={handleChange}
                      handleFocus={handleFocus}
                      handleBlur={handleBlur}
                      handleKeyDown={handleKeyDown}
                      ref={inputRefs.default_title_to_print}
                      data={state}
                      setData={setState}
                      colLabel="col-4"
                      colInput="col-7"
                    />
                    {state.select_type_of_voucher === "Receipt" && (
                      <InputField
                        lable="Print formal receipt after saving"
                        name="print_formal_receipt_after_saving"
                        value={print_formal_receipt_after_saving}
                        handleChange={handleChange}
                        handleFocus={handleFocus}
                        handleBlur={handleBlur}
                        handleKeyDown={handleKeyDown}
                        ref={inputRefs.print_formal_receipt_after_saving}
                        isDrop={true}
                        show_drop={
                          modal_state.print_formal_receipt_after_saving
                        }
                        data={state}
                        setData={setState}
                        handleDropdownClick={handleDropdownClick}
                        height="auto"
                      />
                    )}
                    {(state.select_type_of_voucher === "Sales" ||
                      state.select_type_of_voucher === "Purchase Order" ||
                      state.select_type_of_voucher === "Sales Order") && (
                        <InputField
                          lable="Set/alter declaration"
                          name="set_alter_declaration"
                          value={set_alter_declaration}
                          handleChange={handleChange}
                          handleFocus={handleFocus}
                          handleBlur={handleBlur}
                          handleKeyDown={handleKeyDown}
                          ref={inputRefs.set_alter_declaration}
                          isDrop={true}
                          show_drop={modal_state.set_alter_declaration}
                          data={state}
                          setData={setState}
                          handleDropdownClick={handleDropdownClick}
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="col-12" style={{ padding: "0", width: "100%", pointerEvents: 'auto' }}>
                <MasterCreationFooter setHash={setHashtag} />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="help"></div>
    </div>
  );
}

export default VouchersType;
